import Check from 'components/Form/Check';
import { memo, useCallback, useEffect, useState } from 'react';
import { CheckboxContainer } from './styled';
import { defaultCheckListItemN } from './utils';

const ObservationChecklistN = ({ onChange, defaultValue }) => {
  const [selectedChecklistIds, setSelectedChecklistIds] =
    useState(defaultValue);

  useEffect(() => {
    if (defaultValue) {
      onChange(defaultValue);
    }
  }, []);

  const toggleChecklistItem = useCallback(
    (itemId) => {
      const newChecklistItems = selectedChecklistIds?.includes(itemId)
        ? selectedChecklistIds.filter((checkedId) => checkedId !== itemId)
        : [...selectedChecklistIds, itemId];

      onChange(newChecklistItems);

      setSelectedChecklistIds(newChecklistItems);
    },
    [selectedChecklistIds, onChange]
  );

  const MemoizedCheck = useCallback(
    (checkbox) => (
      <Check
        {...checkbox}
        key={checkbox?.id}
        checked={selectedChecklistIds?.includes(checkbox?.id)}
        onChange={() => toggleChecklistItem(checkbox?.id)}
        nowrap
      />
    ),
    [selectedChecklistIds, toggleChecklistItem]
  );

  return (
    <CheckboxContainer>
      {defaultCheckListItemN.map((checkbox) => (
        <MemoizedCheck {...checkbox} />
      ))}
    </CheckboxContainer>
  );
};

export default memo(ObservationChecklistN);
